import { dailyJackpotRewards, luckyWheelRewards } from '../LuckyWheelConstants';
import {
  computeRewardFromSpin,
  getDailyJackpotRewardIndex,
  updateAdSpinData,
  updateFreeSpinData,
} from '../LuckyWheelUtils';
import type { LuckyWheelDependencies, LuckyWheelReward } from '../types';

export function performLuckyWheelSpin(dependencies: LuckyWheelDependencies, isAdSpin: boolean): { index: number, reward: LuckyWheelReward | null } {
  const { observable } = dependencies;

  const rewardIndex = computeRewardFromSpin(observable, false);

  let reward: LuckyWheelReward | null = null;

  if (luckyWheelRewards[rewardIndex].isJackpot) {
    reward = dailyJackpotRewards[getDailyJackpotRewardIndex()];
  } else {
    reward = luckyWheelRewards[rewardIndex].reward ?? null;
  }

  if (!reward) return { index: -1, reward: null };

  dependencies.addResources({ [reward.resource]: reward.quantity }, isAdSpin);

  if (isAdSpin) updateAdSpinData(dependencies, rewardIndex);
  else updateFreeSpinData(dependencies, rewardIndex);

  return { index: rewardIndex, reward };
}
